@for (field of field.fieldGroup; track field; let index = $index) {
  <div>
    <formly-field [field]="field" />
    <p (click)="remove(index)" class="mt-1 cursor-pointer remove">Remove</p>
  </div>
}

<div>
  <ds-button variant="secondary" size="s" [label]="props.addText" (click)="add()" />
</div>
